webpackJsonp([28,26],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	
	
	'use strict';
	
	var _from = __webpack_require__(224);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _vue = __webpack_require__(466);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _ravenJs = __webpack_require__(387);
	
	var _ravenJs2 = _interopRequireDefault(_ravenJs);
	
	var _vue3 = __webpack_require__(383);
	
	var _vue4 = _interopRequireDefault(_vue3);
	
	var _vueRouter = __webpack_require__(465);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _veeValidate = __webpack_require__(389);
	
	var _veeValidate2 = _interopRequireDefault(_veeValidate);
	
	__webpack_require__(380);
	
	var _session = __webpack_require__(23);
	
	var _validators = __webpack_require__(221);
	
	var _validators2 = _interopRequireDefault(_validators);
	
	var _toolbox = __webpack_require__(222);
	
	var _toolbox2 = _interopRequireDefault(_toolbox);
	
	var _App = __webpack_require__(390);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _routes = __webpack_require__(223);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_ravenJs2.default.config('https://f6ef4b0e0e8a471bad155a93e66b6188@sentry.io/117338').addPlugin(_vue4.default, _vue2.default).install();
	
	if (browserSupportsAllFeatures()) {
	  main();
	} else {
	  loadScript();
	}
	
	function main() {
	
	  _vue2.default.use(_vueRouter2.default);
	  _vue2.default.use(_veeValidate2.default);
	  (0, _validators2.default)(_veeValidate2.default.Validator);
	  _vue2.default.use(_toolbox2.default);
	
	  var router = new _vueRouter2.default({
	    mode: 'history',
	    routes: _routes2.default,
	    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
	      return {
	        x: 0,
	        y: 0
	      };
	    }
	  });
	
	  router.beforeEach(function (to, from, next) {
	    NProgress.start();
	    if (to.name === 'home' && !router.app.$isTokenExpired()) {
	      switch (router.app.$getUser().role) {
	        case router.app.$userRoles.admin:
	          next({
	            name: 'admin.customers'
	          });
	          break;
	        case router.app.$userRoles.customer:
	          next({
	            name: 'customer.dashboard'
	          });
	          break;
	        case router.app.$userRoles.courier:
	          next({
	            name: 'courier.customers'
	          });
	          break;
	      }
	    } else {
	      if ((0, _session.isEligible)(to.meta.role)) {
	        next();
	      } else {
	        next('restrict');
	      }
	    }
	  });
	
	  router.afterEach(function (to, from) {
	    NProgress.done();
	  });
	
	  new _vue2.default({
	    el: '#app',
	    router: router,
	    render: function render(h) {
	      return h(_App2.default);
	    }
	  }).$mount('#app');
	}
	
	function browserSupportsAllFeatures() {
	  return window.Promise && window.fetch && window.Symbol && _from2.default;
	}
	
	function loadScript() {
	  var js = document.createElement('script');
	  var src = "https://cdn.polyfill.io/v2/polyfill.min.js?features=Promise,fetch,Symbol,Array.from,Array.prototype.@@iterator";
	
	  js.src = src;
	  js.onload = function (done) {
	    main();
	  };
	  js.onerror = function () {
	    throw new Error('Failed to load pollyfill script ' + src);
	  };
	  document.head.appendChild(js);
	}

/***/ },

/***/ 23:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isTokenExpired = isTokenExpired;
	exports.getToken = getToken;
	exports.login = login;
	exports.getUser = getUser;
	exports.logout = logout;
	exports.isAuth = isAuth;
	exports.isEligible = isEligible;
	exports.isAllowed = isAllowed;
	var Roles = exports.Roles = {
	  public: 0,
	  admin: 1,
	  manager: 2,
	  courier: 3,
	  supplier: 7,
	  customer: 8
	};
	
	function urlBase64Decode(str) {
	  var output = str.replace(/-/g, '+').replace(/_/g, '/');
	  switch (output.length % 4) {
	    case 0:
	      {
	        break;
	      }
	    case 2:
	      {
	        output += '==';
	        break;
	      }
	    case 3:
	      {
	        output += '=';
	        break;
	      }
	    default:
	      {
	        throw 'Illegal base64url string!';
	      }
	  }
	
	  return decodeURIComponent(escape(typeof window === 'undefined' ? atob(output) : window.atob(output)));
	}
	
	function decodeToken(token) {
	  var parts = token.split('.');
	  if (parts.length !== 3) {
	    throw new Error('JWT must have 3 parts');
	  }
	
	  var decoded = urlBase64Decode(parts[1]);
	  if (!decoded) {
	    throw new Error('Cannot decode the token');
	  }
	
	  return JSON.parse(decoded);
	}
	
	function getTokenExpirationDate(token) {
	  var decoded;
	  decoded = decodeToken(token);
	
	  if (typeof decoded.exp === "undefined") {
	    return null;
	  }
	
	  var date = new Date(0);
	  date.setUTCSeconds(decoded.exp);
	
	  return date;
	}
	
	function isTokenExpired() {
	  if (window.localStorage.id_token) {
	    var date = getTokenExpirationDate(window.localStorage.id_token);
	    var offsetSeconds = 0;
	    if (date === null) {
	      return false;
	    }
	
	    return !(date.valueOf() > new Date().valueOf() + offsetSeconds * 1000);
	  } else {
	    return true;
	  }
	}
	function getToken() {
	  return window.localStorage.id_token;
	}
	function login(token) {
	  window.localStorage.id_token = token;
	}
	
	function getUser() {
	
	  if (window.localStorage.id_token) {
	    return decodeToken(window.localStorage.id_token);
	  } else {
	    return {
	      role: Roles.public
	    };
	  }
	}
	
	function logout() {
	  window.localStorage.clear();
	}
	function isAuth() {
	  return typeof window.localStorage.id_token === "undefined" ? false : true;
	}
	
	function isEligible() {
	  var role = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  if (role.indexOf(Roles.public) > -1) {
	    return true;
	  } else {
	    return role.indexOf(getUser().role) > -1 ? true : false;
	  }
	}
	
	function isAllowed(role) {
	  if (getUser().role === role || role === Roles.public) {
	    return true;
	  } else {
	    return false;
	  }
	}

/***/ },

/***/ 57:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(20);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	exports.default = RPC;
	
	var _session = __webpack_require__(23);
	
	var _settings = __webpack_require__(58);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function handleErrors(response) {
	    if (!response.ok) {
	        throw Error(response.statusText.substr(6));
	    }
	    return response;
	}
	function parseJSON(response) {
	    return response.json();
	}
	function RPC(param, auth) {
	    var httpHeaders = new Headers();
	    httpHeaders.append('Content-Type', 'application/json');
	    httpHeaders.append('Accept', 'application/json');
	    if (auth && !(0, _session.isTokenExpired)()) {
	        httpHeaders.append('Authorization', 'Bearer ' + (0, _session.getToken)());
	    }
	    return fetch(_settings2.default.serverUrl + 'actions', {
	        method: 'POST',
	        headers: httpHeaders,
	        body: (0, _stringify2.default)(param)
	    }).then(handleErrors).then(parseJSON);
	}

/***/ },

/***/ 58:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Settings = {
	  serverUrl: "https://restock-01.herokuapp.com/",
	
	  imagesUrl: "https://restock.gitlab.io/static/"
	
	};
	
	exports.default = Settings;

/***/ },

/***/ 59:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(60);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Script2 = {
	  p: _promise2.default.resolve(),
	
	  loaded: {},
	  load: function load(src) {
	    var opts = arguments.length <= 1 || arguments[1] === undefined ? { parent: document.head } : arguments[1];
	
	    return Script2.loaded[src] ? _promise2.default.resolve(src) : new _promise2.default(function (resolve, reject) {
	      var s = document.createElement('script');
	
	      s.async = false;
	      s.src = src;
	
	      s.crossOrigin = opts.crossorigin;
	
	      s.onload = function () {
	        Script2.loaded[src] = 1;
	        resolve(src);
	      };
	
	      s.onerror = function () {
	        return reject(new Error(src));
	      };
	      opts.parent.appendChild(s);
	    });
	  },
	  unload: function unload() {
	    delete Script2.loaded[this.src];
	  }
	};
	exports.default = Script2;

/***/ },

/***/ 182:
/***/ function(module, exports) {

	
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      menuItems: []
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    if (!this.$isTokenExpired()) {
	      this.setMenu();
	    }
	
	    this.$root.$on('onLogin', function (e) {
	      _this.setMenu();
	      switch (_this.$getUser().role) {
	        case _this.$userRoles.admin:
	          _this.$router.push({ name: 'admin.customers' });
	          break;
	        case _this.$userRoles.customer:
	          _this.$router.push({ name: 'customer.dashboard' });
	          break;
	        case _this.$userRoles.courier:
	          _this.$router.push({ name: 'courier.customers' });
	          break;
	      }
	    });
	  },
	  destroyed: function destroyed() {
	    this.$root.$off('onLogin');
	  },
	
	  methods: {
	    onHome: function onHome() {
	      if (!this.$isAuth()) {
	        this.$router.push('/');
	      }
	    },
	    onMenu: function onMenu() {
	      this.$refs.sidebar.toggle();
	    },
	    setMenu: function setMenu() {
	      switch (this.$getUser().role) {
	        case this.$userRoles.admin:
	          this.menuItems = [{
	            name: 'customers',
	            link: '/admin/customers',
	            label: 'Customers List',
	            icon: 'users'
	          }, {
	            name: 'users',
	            link: '/admin/users',
	            label: 'Users List',
	            icon: 'street view'
	          }, {
	            name: 'products',
	            link: '/admin/products',
	            label: 'Products List',
	            icon: 'tags'
	          }, {
	            name: 'stock',
	            link: '/admin/stock',
	            label: 'Stock in Hand',
	            icon: 'barcode'
	          }, {
	            name: 'restock',
	            link: '/admin/Restock',
	            label: 'Restock',
	            icon: 'repeat'
	          }, {
	            name: 'shipments',
	            link: '/admin/shipments',
	            label: 'Shipments',
	            icon: 'shipping'
	          }, {
	            name: 'invoices',
	            link: '/admin/invoices',
	            label: 'Customer Invoices',
	            icon: 'file text outline'
	          }, {
	            name: 'suppliers',
	            link: '/admin/suppliers',
	            label: 'Suppliers',
	            icon: 'options'
	          }, {
	            name: 'settings',
	            link: '/admin/settings',
	            label: 'Settings',
	            icon: 'setting'
	          }, {
	            name: 'tools',
	            link: '/admin/tools',
	            label: 'Tools',
	            icon: 'configure'
	          }];
	
	          break;
	        case this.$userRoles.customer:
	          this.menuItems = [{
	            name: 'dashboard',
	            link: '/customer/dashboard',
	            label: 'Dashboard',
	            icon: 'pie chart'
	          }, {
	            name: 'marketplace',
	            link: '/customer/marketplace',
	            label: 'Marketplace',
	            icon: 'tags'
	          }, {
	            name: 'subscriptions',
	            link: '/customer/subscriptions',
	            label: 'Subscriptions',
	            icon: 'unhide'
	          }, {
	            name: 'requestions',
	            link: '/customer/requisitions',
	            label: 'Requisitions',
	            icon: 'payment'
	          }, {
	            name: 'purchaseorder',
	            link: '/customer/orders',
	            label: 'Purchase Order',
	            icon: 'shop'
	          }, {
	            name: 'invoices',
	            link: '/customer/invoices',
	            label: 'Invoices',
	            icon: 'file text outline'
	          }, {
	            name: 'account',
	            link: '/customer/account',
	            label: 'Account',
	            icon: 'user'
	          }];
	          break;
	        case this.$userRoles.courier:
	          this.menuItems = [{
	            name: 'customerlist',
	            link: '/courier/customers',
	            label: 'Customer List',
	            icon: 'users'
	          }];
	
	          break;
	        default:
	
	      }
	    },
	    onSignout: function onSignout() {
	      this.$logout();
	      this.$router.push('/login');
	    }
	  }
	
	};

/***/ },

/***/ 183:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'constatus',
	  props: {},
	
	  data: function data() {
	    return {
	      showBackDrop: false
	
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    if (!!window.EventSource) {
	      window.eSource = new EventSource(this.$streamUrl + "?user=" + this.$getUser()._id);
	
	      window.eSource.onopen = function (e) {
	        console.log("Connected");
	        _this.close();
	      };
	
	      window.eSource.onerror = function (e) {
	        _this.open();
	        switch (window.eSource.readyState) {
	          case EventSource.CLOSED:
	            console.log("Disconnected");
	            break;
	
	          case EventSource.CONNECTING:
	            console.log("Connecting ...");
	            break;
	        }
	      };
	    } else {
	      window.addEventListener('online', function (event) {
	        _this.close();
	      });
	      window.addEventListener('offline', function (event) {
	        console.log('offline');
	        _this.open();
	      });
	    }
	  },
	  mounted: function mounted() {
	    document.body.classList.add("dimmable");
	  },
	  destroyed: function destroyed() {
	    window.eSource.close();
	    delete window.eSource;
	  },
	
	
	  methods: {
	    open: function open() {
	      this.showBackDrop = true;
	      document.body.classList.add("dimmed");
	    },
	    close: function close() {
	      this.showBackDrop = false;
	      document.body.classList.remove("dimmed");
	    }
	  }
	};

/***/ },

/***/ 184:
/***/ function(module, exports) {

	
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'loadmore',
	  props: {
	    type: {
	      type: String,
	      default: 'items'
	    },
	    isBusy: {
	      type: Boolean,
	      default: false
	    },
	    isError: {
	      type: Boolean,
	      default: false
	    },
	    count: {
	      type: Number,
	      default: 0
	    },
	    totalCount: {
	      type: Number,
	      default: 0
	    },
	    onRetry: {
	      type: Function,
	      required: true
	    },
	    onViewMore: {
	      type: Function,
	      required: true
	    }
	  }
	};

/***/ },

/***/ 185:
/***/ function(module, exports) {

	
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'message',
	  data: function data() {
	    return {
	      hide: true,
	      type: 'info',
	      icon: '',
	      text: '',
	      info: true,
	      warning: false,
	      success: false,
	      error: false
	    };
	  },
	
	  methods: {
	    show: function show() {
	      var _this = this;
	
	      this.hide = false;
	      setTimeout(function () {
	        _this.hide = true;
	      }, 3300);
	    },
	    hide: function hide() {
	      this.hide = true;
	    },
	    setType: function setType(type) {
	      this.info = false;
	      this.warning = false;
	      this.success = false;
	      this.error = false;
	      switch (type) {
	        case 'info':
	          this.info = true;
	          this.icon = 'info circle';
	          break;
	        case 'warning':
	          this.warning = true;
	          this.icon = 'warning sign';
	          break;
	        case 'success':
	          this.success = true;
	          this.icon = 'hand peace';
	          break;
	        case 'error':
	          this.error = true;
	          this.icon = 'help circle';
	          break;
	      }
	    },
	    setText: function setText(text) {
	      this.text = text;
	    }
	  }
	};

/***/ },

/***/ 186:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'modal',
	  props: {
	    size: {
	      type: String,
	      default: 'small'
	    },
	    type: {
	      type: String,
	      default: ''
	    },
	    closeable: {
	      type: Boolean,
	      default: true
	    },
	    isScroll: {
	      type: Boolean,
	      default: false
	    }
	
	  },
	
	  data: function data() {
	    return {
	      id: 'modal_' + Math.random(),
	      showBackDrop: false,
	      showModal: false
	    };
	  },
	  mounted: function mounted() {
	    document.body.classList.add("dimmable");
	  },
	
	
	  methods: {
	    clickContent: function clickContent(event) {
	      event.stopPropagation();
	    },
	    open: function open() {
	      var _this = this;
	
	      this.showBackDrop = true;
	      document.body.classList.add("dimmed");
	
	      this.showModal = true;
	      this.$nextTick(function () {
	        _this.$el.firstChild.style.top = (document.body.offsetHeight - _this.$el.firstChild.offsetHeight) / 2 + 'px';
	      });
	    },
	    close: function close() {
	      var _this2 = this;
	
	      this.showModal = false;
	      setTimeout(function () {
	        _this2.showBackDrop = false;
	        document.body.classList.remove("dimmed");
	      }, 30);
	    },
	    closeModal: function closeModal() {
	      if (!this.closeable) {
	        return;
	      }
	      this.close();
	    }
	  }
	};

/***/ },

/***/ 187:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'onerror',
	  props: {},
	
	  data: function data() {
	    return {
	      showBackDrop: false
	
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    window.addEventListener("unhandledrejection", function (e) {
	      console.log(e);
	      console.warn("WARNING: Unhandled promise rejection." + e.reason);
	    });
	
	    window.onerror = function (msg, src, line) {
	      console.log(msg);
	      console.log(src);
	      console.log(line);
	      _this.open();
	
	      return true;
	    };
	  },
	  mounted: function mounted() {
	    document.body.classList.add("dimmable");
	  },
	
	  methods: {
	    open: function open() {
	      document.body.classList.add("dimmed");
	      this.showBackDrop = true;
	    },
	    close: function close() {
	      this.showBackDrop = false;
	      document.body.classList.remove("dimmed");
	    },
	    onRefresh: function onRefresh() {
	      window.location.reload();
	    }
	  }
	};

/***/ },

/***/ 188:
/***/ function(module, exports) {

	
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'sidebar',
	  created: function created() {
	    var _this = this;
	
	    document.addEventListener("click", function () {
	      _this.onDocClick();
	    });
	  },
	  destroyed: function destroyed() {
	    var _this2 = this;
	
	    document.removeEventListener("click", function () {
	      _this2.onDocClick();
	    });
	  },
	  data: function data() {
	    return {
	      isMenu: false
	
	    };
	  },
	
	  methods: {
	    onDocClick: function onDocClick() {
	      if (this.isMenu) {
	        this.isMenu = false;
	      }
	    },
	    toggle: function toggle() {
	      if (this.isMenu) {
	        this.isMenu = false;
	      } else {
	        this.isMenu = true;
	      }
	    }
	  }
	};

/***/ },

/***/ 190:
/***/ function(module, exports) {

	
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'emptylist',
	  data: function data() {
	    return {};
	  },
	
	  methods: {}
	};

/***/ },

/***/ 191:
/***/ function(module, exports) {

	
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'errmsg'
	};

/***/ },

/***/ 214:
/***/ function(module, exports, __webpack_require__) {

	
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _script = __webpack_require__(59);
	
	var _script2 = _interopRequireDefault(_script);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'home',
	  data: function data() {
	
	    return {};
	  },
	  created: function created() {
	    if (!this.$isMobile) {
	      _script2.default.load('https://safi.me.uk/typewriterjs/js/typewriter.js').then(function () {
	        var typewriter = new Typewriter(document.getElementById('type'), {
	          loop: true,
	          typingSpeed: 30,
	          deleteSpeed: 25
	        });
	
	        typewriter.typeString('INVENTORY MANAGEMENT ON AUTOPILOT').pauseFor(2500).deleteAll().typeString('NEVER RUN OUT OF OFFICE SUPPLIES AGAIN!').pauseFor(2500).deleteAll().typeString('FIND EVERYTHING YOUR OFFICE NEEDS').pauseFor(2500).deleteAll().start();
	      }).catch(function (err) {});
	    }
	  },
	
	  methods: {}
	};

/***/ },

/***/ 221:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(60);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _slicedToArray2 = __webpack_require__(230);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.default = Validators;
	
	var _server = __webpack_require__(57);
	
	var _server2 = _interopRequireDefault(_server);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Validators(validator) {
	
	  validator.extend('verifyemail', {
	    getMessage: function getMessage(field) {
	      return field + ' already exists. Try a differnt ' + field;
	    },
	    validate: function validate(value, _ref) {
	      var _ref2 = (0, _slicedToArray3.default)(_ref, 1),
	          args = _ref2[0];
	
	      return new _promise2.default(function (resolve) {
	        (0, _server2.default)({
	          method: "user.emailcheck",
	          args: args ? { e: value, cId: args } : { e: value }
	        }).then(function (data) {
	          resolve({
	            valid: data.valid
	          });
	        }).catch(function (err) {
	          console.log(err);
	          resolve({
	            valid: false
	          });
	        });
	      });
	    }
	  });
	}

/***/ },

/***/ 222:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Message = __webpack_require__(393);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	var _Modal = __webpack_require__(394);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Sidebar = __webpack_require__(396);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _Loadmore = __webpack_require__(392);
	
	var _Loadmore2 = _interopRequireDefault(_Loadmore);
	
	var _ConStatus = __webpack_require__(391);
	
	var _ConStatus2 = _interopRequireDefault(_ConStatus);
	
	var _OnError = __webpack_require__(395);
	
	var _OnError2 = _interopRequireDefault(_OnError);
	
	var _emptylist = __webpack_require__(398);
	
	var _emptylist2 = _interopRequireDefault(_emptylist);
	
	var _errmsg = __webpack_require__(399);
	
	var _errmsg2 = _interopRequireDefault(_errmsg);
	
	var _session = __webpack_require__(23);
	
	var _server = __webpack_require__(57);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _settings = __webpack_require__(58);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tools = {};
	
	function isEmpty(obj) {
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	  if (obj == null) return true;
	
	  if (obj.length > 0) return false;
	  if (obj.length === 0) return true;
	
	  for (var key in obj) {
	    if (hasOwnProperty.call(obj, key)) return false;
	  }
	
	  return true;
	}
	
	tools.install = function (Vue, options) {
	  Vue.myGlobalMethod = function () {
	    console.log('Global');
	  };
	
	
	  Vue.directive('focus', {
	    inserted: function inserted(el) {
	      el.focus();
	    }
	  });
	
	  Vue.component('message', _Message2.default);
	  Vue.component('modal', _Modal2.default);
	  Vue.component('sidebar', _Sidebar2.default);
	  Vue.component('loadmore', _Loadmore2.default);
	  Vue.component('constatus', _ConStatus2.default);
	  Vue.component('onerror', _OnError2.default);
	  Vue.component('emptylist', _emptylist2.default);
	  Vue.component('errmsg', _errmsg2.default);
	
	  Vue.mixin({
	    data: function data() {
	      return {};
	    },
	
	    created: function created() {}
	
	  });
	
	  Vue.prototype.$server = {};
	  Vue.prototype.$server.rpc = _server2.default;
	  Vue.prototype.$userRoles = _session.Roles;
	  Vue.prototype.$getUser = _session.getUser;
	  Vue.prototype.$login = _session.login;
	  Vue.prototype.$logout = _session.logout;
	  Vue.prototype.$isAuth = _session.isAuth;
	  Vue.prototype.$isAllowed = _session.isAllowed;
	  Vue.prototype.$isTokenExpired = _session.isTokenExpired;
	  Vue.prototype.$getToken = _session.getToken;
	  Vue.prototype.$isEmpty = isEmpty;
	  Vue.prototype.$formatDateTime = function (date) {
	    date = new Date(date);
	    return date.toDateString() + ' ' + date.toLocaleTimeString();
	  };
	
	  Vue.prototype.$formatDate = function (date) {
	    date = new Date(date);
	    return date.toString().substr(0, 16);
	  };
	  Vue.prototype.$isMobile = Vue.util.isAndroid || Vue.util.isIOS ? true : false;
	  Vue.prototype.$capitalize = Vue.util.capitalize;
	  Vue.prototype.$plural = function (unit, qty) {
	    if (unit !== null && qty !== null) {
	      return unit !== null && qty > 1 ? unit + 's' : unit;
	    }
	  };
	  Vue.prototype.$streamUrl = _settings2.default.serverUrl + 'stream';
	  Vue.prototype.$imgUrl = function (url) {
	    return url !== null ? _settings2.default.imagesUrl + url : _settings2.default.imagesUrl + 'placeholder.png';
	  };
	  Vue.prototype.$calcPrice = function (item) {
	    if (item) {
	      return item.o >= item.p.wq ? item.p.wp : item.p.rp;
	    }
	  }, Vue.prototype.$calcOrderAmt = function (item) {
	    if (item) {
	      return item.o < item.p.wq ? Math.round(item.o * item.p.rp) : Math.round(item.o * item.p.wp);
	    }
	  };
	};
	
	exports.default = tools;

/***/ },

/***/ 223:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Home = __webpack_require__(421);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _session = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{
	  path: '/',
	  name: 'home',
	  component: _Home2.default,
	  meta: {
	    role: [_session.Roles.public]
	  }
	}, {
	  path: '/login',
	  name: 'login',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(20, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(422)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  meta: {
	    role: [_session.Roles.public]
	  }
	}, {
	  path: '/signup',
	  name: 'signup',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(19, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(423)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  meta: {
	    role: [_session.Roles.public]
	  }
	}, {
	  path: '/thankyou',
	  name: 'thankyou',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(18, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(424)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  meta: {
	    role: [_session.Roles.public]
	  }
	}, {
	  path: '/restrict',
	  name: 'restrict',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(16, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(426)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  meta: {
	    role: [_session.Roles.public]
	  }
	}, {
	  path: '/admin/customers',
	  name: 'admin.customers',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(7, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(402)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  meta: {
	    role: [_session.Roles.admin]
	  }
	}, {
	  path: '/admin/customer/:custId',
	  name: 'admin.customer',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(0, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(181)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  meta: {
	    role: [_session.Roles.admin]
	  }
	}, {
	  path: '/admin/users',
	  name: 'admin.users',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(5, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(410)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  meta: {
	    role: [_session.Roles.admin]
	  }
	}, {
	  path: '/admin/products',
	  name: 'admin.products',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(13, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(404)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  meta: {
	    role: [_session.Roles.admin]
	  }
	}, {
	  path: '/admin/stock',
	  name: 'admin.stock',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(11, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(407)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  meta: {
	    role: [_session.Roles.admin]
	  }
	}, {
	  path: '/admin/invoices',
	  name: 'admin.invoices',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(6, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(403)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  meta: {
	    role: [_session.Roles.admin]
	  }
	}, {
	  path: '/admin/suppliers',
	  name: 'admin.suppliers',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(10, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(408)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  meta: {
	    role: [_session.Roles.admin]
	  }
	}, {
	  path: '/admin/settings',
	  name: 'admin.settings',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(24, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(406)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  meta: {
	    role: [_session.Roles.admin]
	  },
	  children: [{
	    path: 'company',
	    name: 'admin.settings.company',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(25, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(401)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    meta: {
	      role: [_session.Roles.admin]
	    }
	  }, {
	    path: 'regions',
	    name: 'admin.settings.regions',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(12, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(405)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    meta: {
	      role: [_session.Roles.admin]
	    }
	  }, {
	    path: 'categories',
	    name: 'admin.settings.categories',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(14, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(400)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    meta: {
	      role: [_session.Roles.admin]
	    }
	  }]
	}, {
	  path: '/admin/tools',
	  name: 'admin.tools',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(23, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(409)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  meta: {
	    role: [_session.Roles.admin]
	  }
	}, {
	  path: '/customer/dashboard',
	  name: 'customer.dashboard',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(1, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(415)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  meta: {
	    role: [_session.Roles.customer]
	  }
	}, {
	  path: '/customer/marketplace',
	  name: 'customer.marketplace',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(4, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(417)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  meta: {
	    role: [_session.Roles.customer]
	  }
	}, {
	  path: '/customer/subscriptions',
	  name: 'customer.subscriptions',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(2, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(420)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  meta: {
	    role: [_session.Roles.customer]
	  }
	}, {
	  path: '/customer/requisitions',
	  name: 'customer.requisitions',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(8, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(419)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  meta: {
	    role: [_session.Roles.customer]
	  }
	}, {
	  path: '/customer/orders',
	  name: 'customer.orders',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(9, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(418)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  meta: {
	    role: [_session.Roles.customer]
	  }
	}, {
	  path: '/customer/invoices',
	  name: 'customer.invoices',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(21, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(416)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  meta: {
	    role: [_session.Roles.customer]
	  }
	}, {
	  path: '/customer/account',
	  name: 'customer.account',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(181)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  meta: {
	    role: [_session.Roles.customer]
	  }
	}, {
	  path: '/courier/customers',
	  name: 'courier.customers',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(22, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(412)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  meta: {
	    role: [_session.Roles.courier]
	  }
	}, {
	  path: '/courier/invoices/:custId/company/:companyName',
	  name: 'courier.invoices',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(3, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(414)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  meta: {
	    role: [_session.Roles.courier]
	  }
	}, {
	  path: '/print/invoice/:invId',
	  name: 'print.invoice',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(15, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(411)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  meta: {
	    role: [_session.Roles.admin, _session.Roles.courier, _session.Roles.customer]
	  }
	}, {
	  path: '*',
	  name: 'notfount',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(17, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(425)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  meta: {
	    role: [_session.Roles.public]
	  }
	}];

/***/ },

/***/ 343:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 348:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 352:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 360:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 362:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 365:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 366:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 376:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 378:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 380:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 390:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(360)
	
	/* script */
	__vue_exports__ = __webpack_require__(182)
	
	/* template */
	var __vue_template__ = __webpack_require__(445)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },

/***/ 391:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(366)
	
	/* script */
	__vue_exports__ = __webpack_require__(183)
	
	/* template */
	var __vue_template__ = __webpack_require__(451)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },

/***/ 392:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(343)
	
	/* script */
	__vue_exports__ = __webpack_require__(184)
	
	/* template */
	var __vue_template__ = __webpack_require__(427)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-07e0e861"
	
	module.exports = __vue_exports__


/***/ },

/***/ 393:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(378)
	
	/* script */
	__vue_exports__ = __webpack_require__(185)
	
	/* template */
	var __vue_template__ = __webpack_require__(463)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-df29a15e"
	
	module.exports = __vue_exports__


/***/ },

/***/ 394:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(365)
	
	/* script */
	__vue_exports__ = __webpack_require__(186)
	
	/* template */
	var __vue_template__ = __webpack_require__(450)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },

/***/ 395:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(362)
	
	/* script */
	__vue_exports__ = __webpack_require__(187)
	
	/* template */
	var __vue_template__ = __webpack_require__(447)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },

/***/ 396:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(376)
	
	/* script */
	__vue_exports__ = __webpack_require__(188)
	
	/* template */
	var __vue_template__ = __webpack_require__(461)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-a80aefb4"
	
	module.exports = __vue_exports__


/***/ },

/***/ 398:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(352)
	
	/* script */
	__vue_exports__ = __webpack_require__(190)
	
	/* template */
	var __vue_template__ = __webpack_require__(436)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-28b93055"
	
	module.exports = __vue_exports__


/***/ },

/***/ 399:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(191)
	
	/* template */
	var __vue_template__ = __webpack_require__(440)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },

/***/ 421:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(348)
	
	/* script */
	__vue_exports__ = __webpack_require__(214)
	
	/* template */
	var __vue_template__ = __webpack_require__(432)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1b9e5587"
	
	module.exports = __vue_exports__


/***/ },

/***/ 427:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "ui middle aligned center aligned grid loadmore"
	  }, [_c('div', {
	    staticClass: "column padzero"
	  }, [_c('div', {
	    staticClass: "ui pointing below medium label",
	    class: {
	      'grey': _vm.isBusy, 'green': !_vm.isError && !_vm.isBusy, 'red': _vm.isError
	    }
	  }, [_c('i', {
	    staticClass: "icon",
	    class: {
	      'hourglass half': _vm.isBusy, 'file text outline': !_vm.isError && !_vm.isBusy, 'warning sign': _vm.isError && !_vm.isBusy
	    }
	  }), _vm._v(" "), (_vm.isBusy) ? _c('div', [_vm._v("Loading ...     ")]) : _vm._e(), _vm._v(" "), (!_vm.isError && !_vm.isBusy) ? _c('div', [_vm._v("Showing " + _vm._s(_vm.count) + " of " + _vm._s(_vm.totalCount) + " " + _vm._s(_vm.type))]) : _vm._e(), _vm._v(" "), (_vm.isError && !_vm.isBusy) ? _c('div', [_vm._v("Server or network error")]) : _vm._e(), _vm._v(" "), (_vm.isError && !_vm.isBusy) ? _c('a', {
	    staticClass: "detail",
	    on: {
	      "click": function($event) {
	        _vm.onRetry()
	      }
	    }
	  }, [_vm._v("Retry")]) : _vm._e(), _vm._v(" "), (_vm.count < _vm.totalCount && !_vm.isError && !_vm.isBusy) ? _c('a', {
	    staticClass: "detail",
	    on: {
	      "click": function($event) {
	        _vm.onViewMore()
	      }
	    }
	  }, [_vm._v("View More")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "ui centered inline loader",
	    class: {
	      'active': _vm.isBusy
	    }
	  })])])
	},staticRenderFns: []}

/***/ },

/***/ 432:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "ui grid"
	  }, [_c('section', {
	    staticClass: "row intro"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin-bottom": "2em"
	    }
	  }, [_c('h2', {
	    attrs: {
	      "id": "type"
	    }
	  }, [_vm._v("INVENTORY MANAGEMENT ON AUTOPILOT")]), _vm._v(" "), _c('h4', [_vm._v("Restock is a dedicated subscription based marketplace for office supplies.")]), _vm._v(" "), _c('button', {
	    staticClass: "ui green button",
	    class: {
	      medium: _vm.$isMobile, medium: !_vm.$isMobile
	    },
	    on: {
	      "click": function($event) {
	        _vm.$router.push('signup')
	      }
	    }
	  }, [_vm._v("CREATE FEE ACCOUNT")]), _vm._v(" "), _c('button', {
	    staticClass: "ui orange  button",
	    class: {
	      medium: _vm.$isMobile, medium: !_vm.$isMobile
	    },
	    on: {
	      "click": function($event) {
	        _vm.$router.push('login')
	      }
	    }
	  }, [_vm._v("LOG IN")])]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "scale",
	      "appear": ""
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.$imgUrl('banner.png'),
	      "align": "center"
	    }
	  })])], 1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('section', {
	    staticClass: "centred row try common",
	    staticStyle: {
	      "padding-top": "2em !important"
	    }
	  }, [_c('div', {
	    staticClass: "column centertext"
	  }, [_c('h2', {
	    staticStyle: {
	      "color": "red !important",
	      "font-weight": "100"
	    }
	  }, [_vm._v("Never Run Out Of Office Supplies Again!")]), _vm._v(" "), _c('h3', {
	    staticStyle: {
	      "margin-top": "0",
	      "font-weight": "100",
	      "font-style": "italic"
	    }
	  }, [_vm._v("Find Everthing Your Office Needs")]), _vm._v(" "), _c('button', {
	    staticClass: "ui green medium button",
	    on: {
	      "click": function($event) {
	        _vm.$router.push('signup')
	      }
	    }
	  }, [_vm._v("GET STARTED FOR FREE")])])]), _vm._v(" "), _c('section', {
	    staticClass: "row footer"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('i', {
	    staticClass: "cube large icon"
	  }), _c('span', [_vm._v("An Officeware Company")]), (!_vm.$isMobile) ? _c('span', [_vm._v(" - All rights reserved")]) : _vm._e()])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "ui secondary green pointing compact menu"
	  }, [_c('div', {
	    staticClass: "menu"
	  }, [_c('a', {
	    staticClass: "active item",
	    attrs: {
	      "href": "#why"
	    }
	  }, [_vm._v("\n    Why Restock\n  ")]), _vm._v(" "), _c('a', {
	    staticClass: "item",
	    attrs: {
	      "href": "#features"
	    }
	  }, [_vm._v("\n    Features\n  ")]), _vm._v(" "), _c('a', {
	    staticClass: "item",
	    attrs: {
	      "href": "#works"
	    }
	  }, [_vm._v("\n    How It Works\n  ")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "logo"
	  }, [_c('div', [_c('i', {
	    staticClass: "unhide green large icon"
	  })]), _vm._v(" "), _c('div', [_vm._v("Restock")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "row common why",
	    attrs: {
	      "id": "why"
	    }
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('h2', {
	    staticClass: "centertext spacing"
	  }, [_vm._v("Why Restock ?")]), _vm._v(" "), _c('ul', [_vm._v("\n      How many times have you run out of paper or ink cartridges or something as basic as a felt-tip marker? \n      Wouldn't it be nice if the next time you needed to order office supplies, they were already there?\n      That's the idea behind Restock subscription service. Sign up to receive regular shipments at a designated frequency and you won't have to worry about reordering.\n      ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "row common features",
	    attrs: {
	      "id": "features"
	    }
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('h2', {
	    staticClass: "ui green header centertext spacing"
	  }, [_vm._v("Features")]), _vm._v(" "), _c('ul', [_c('li', {}, [_vm._v("Subscribe products, suspend or cancel subscriptions.")]), _vm._v(" "), _c('li', {}, [_vm._v("Requisitions and invoice management.")]), _vm._v(" "), _c('li', {}, [_vm._v("Auto Order placement on minimum stock level.")]), _vm._v(" "), _c('li', {}, [_vm._v("One Invoice for all monthly supplies.")]), _vm._v(" "), _c('li', {}, [_vm._v("Transparent Retail and Wholesale pricing.")]), _vm._v(" "), _c('li', {}, [_vm._v("Best customer service.")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "row common works",
	    attrs: {
	      "id": "works"
	    }
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('h2', {
	    staticClass: "centertext spacing"
	  }, [_vm._v("How It Works")]), _vm._v(" "), _c('div', {
	    staticClass: "divider"
	  }), _vm._v(" "), _c('ol', {
	    staticClass: "horizontal layout wrap"
	  }, [_c('li', [_vm._v("Create your free account.")]), _vm._v(" "), _c('li', [_vm._v("Subscribe products you reqularly use.")]), _vm._v(" "), _c('li', [_vm._v("Define Min & restock level for your subscriptions.")]), _vm._v(" "), _c('li', [_vm._v("Manage staff requisitions.")]), _vm._v(" "), _c('li', [_vm._v("Receive regular shipments.")]), _vm._v(" "), _c('li', [_vm._v("Pay monthly invoice.")])])])])
	}]}

/***/ },

/***/ 436:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "scale"
	    }
	  }, [_c('div', {
	    staticClass: "centertext emptylist"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.$imgUrl('empty.png')
	    }
	  }), _vm._v(" "), _vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ },

/***/ 440:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "scale"
	    }
	  }, [_c('div', {
	    staticClass: "ui pointing red tiny basic label"
	  }, [_vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ },

/***/ 445:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('sidebar', {
	    ref: "sidebar"
	  }, [_c('div', {
	    staticClass: "centertext"
	  }, [_c('i', {
	    staticClass: "unhide huge icon"
	  }), _vm._v(" "), _c('div', [_vm._v("Hi, " + _vm._s(_vm.$getUser().name))])]), _vm._v(" "), _c('div', {
	    staticClass: "ui inverted divider"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "ui vertical inverted menu"
	  }, _vm._l((_vm.menuItems), function(item) {
	    return _c('a', {
	      staticClass: "item",
	      attrs: {
	        "name": item.name
	      },
	      on: {
	        "click": function($event) {
	          _vm.$router.push(item.link)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "icon",
	      class: [item.icon]
	    }), _vm._v(" " + _vm._s(item.label) + "\n      ")])
	  }))]), _vm._v(" "), (['home', 'login', 'signup', 'thankyou'].indexOf(this.$router.currentRoute.name) === -1) ? _c('section', {
	    staticClass: "ui equal width padded grid",
	    attrs: {
	      "id": "header"
	    }
	  }, [_c('div', {
	    staticClass: "row ui segment toolbar"
	  }, [_c('div', {
	    staticClass: "column",
	    staticStyle: {
	      "padding-right": "0"
	    }
	  }, [_c('a', {
	    staticStyle: {
	      "margin-left": ".1em"
	    },
	    on: {
	      "click": function($event) {
	        _vm.onHome()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "unhide big icon green"
	  }), _vm._m(0)])]), _vm._v(" "), _c('div', {
	    staticClass: "right aligned column",
	    staticStyle: {
	      "padding-left": "0"
	    }
	  }, [(!_vm.$isTokenExpired()) ? _c('div', [_c('div', {
	    staticClass: "ui labeled tiny button",
	    attrs: {
	      "tabindex": "0"
	    }
	  }, [_c('div', {
	    staticClass: "ui grey tiny button",
	    attrs: {
	      "data-tooltip": "Actions List",
	      "data-inverted": "",
	      "data-position": "left center"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.onMenu($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "windows icon"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "ui grey basic label",
	    attrs: {
	      "data-tooltip": "Sign Out",
	      "data-inverted": "",
	      "data-position": "left center"
	    },
	    on: {
	      "click": _vm.onSignout
	    }
	  }, [_c('i', {
	    staticClass: "sign small out icon",
	    staticStyle: {
	      "font-size": "1.2em"
	    }
	  })])])]) : _vm._e(), _vm._v(" "), (_vm.$isTokenExpired()) ? _c('div', [_c('span', {
	    staticStyle: {
	      "letter-spacing": ".07em",
	      "color": "#767676"
	    }
	  }, [_vm._v("Already a customer?")]), _vm._v(" "), _c('button', {
	    staticClass: "ui grey tiny button",
	    attrs: {
	      "data-tooltip": "Login to your account",
	      "data-inverted": "",
	      "data-position": "top right"
	    },
	    on: {
	      "click": function($event) {
	        _vm.$router.push('/login')
	      }
	    }
	  }, [_vm._v("LOG IN")])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('section', {
	    attrs: {
	      "id": "contents"
	    }
	  }, [_c('router-view')], 1), _vm._v(" "), _c('constatus'), _vm._v(" "), _c('onerror')], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "logo"
	  }, [_vm._v("Restock"), _c('i', {
	    staticClass: "registered icon"
	  })])
	}]}

/***/ },

/***/ 447:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(_vm.showBackDrop) ? _c('div', {
	    staticClass: "ui dimmer page",
	    staticStyle: {
	      "display": "block !important"
	    },
	    style: ({
	      visibility: _vm.showBackDrop ? 'visible' : 'hidden',
	      opacity: _vm.showBackDrop ? '1' : '0'
	    })
	  }, [_c('transition', {
	    attrs: {
	      "name": "scale"
	    }
	  }, [_c('div', {
	    staticClass: "ui center aligned middle aligned grid constatus"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', [_c('i', {
	    staticClass: "bug huge icon red"
	  }), _vm._v(" "), _c('h1', [_vm._v("Ooops!")]), _vm._v(" "), _c('h3', [_vm._v("It appears there has been an internal error.")]), _vm._v(" "), _c('h4', [_vm._v("We are working to fix this problem.")]), _vm._v(" "), _c('button', {
	    staticClass: "ui large circular green button",
	    on: {
	      "click": _vm.onRefresh
	    }
	  }, [_c('i', {
	    staticClass: "refresh icon"
	  }), _vm._v("Retry")]), _vm._v(" "), _c('div', {
	    staticClass: "ui horizontal divider",
	    staticStyle: {
	      "color": "white"
	    }
	  }, [_vm._v("Or")]), _vm._v(" "), _c('h3', [_vm._v("Contact us, If the problem persists.")])])])])])], 1) : _vm._e()])
	},staticRenderFns: []}

/***/ },

/***/ 450:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(_vm.showBackDrop) ? _c('div', {
	    staticClass: "ui dimmer modals page",
	    staticStyle: {
	      "display": "block !important",
	      "overflow-y": "scroll"
	    },
	    style: ({
	      visibility: _vm.showBackDrop ? 'visible' : 'hidden',
	      opacity: _vm.showBackDrop ? '1' : '0'
	    }),
	    on: {
	      "click": function($event) {
	        _vm.closeModal()
	      }
	    }
	  }, [_c('transition', {
	    attrs: {
	      "name": "scale"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showModal),
	      expression: "showModal"
	    }],
	    staticClass: "ui modal active visibility",
	    class: [_vm.size, _vm.type, _vm.isScroll ? 'scrolling' : ''],
	    attrs: {
	      "id": _vm.id
	    },
	    on: {
	      "click": function($event) {
	        _vm.clickContent($event)
	      }
	    }
	  }, [_vm._t("default")], 2)])], 1) : _vm._e()])
	},staticRenderFns: []}

/***/ },

/***/ 451:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(_vm.showBackDrop) ? _c('div', {
	    staticClass: "ui dimmer page",
	    staticStyle: {
	      "display": "block !important"
	    },
	    style: ({
	      visibility: _vm.showBackDrop ? 'visible' : 'hidden',
	      opacity: _vm.showBackDrop ? '1' : '0'
	    })
	  }, [_c('transition', {
	    attrs: {
	      "name": "scale"
	    }
	  }, [_c('div', {
	    staticClass: "ui center aligned middle aligned grid constatus"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('i', {
	    staticClass: "signal huge icon red"
	  }), _vm._v(" "), _c('h1', [_vm._v("Connection to Server Lost!")]), _vm._v(" "), _c('h2', [_vm._v("Trying to reconnect")]), _vm._v(" "), _c('span', {
	    staticClass: "ui active inline loader"
	  })])])])], 1) : _vm._e()])
	},staticRenderFns: []}

/***/ },

/***/ 461:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sidebar",
	    class: {
	      'togglebar': !_vm.isMenu
	    }
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ },

/***/ 463:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.hide),
	      expression: "!hide"
	    }],
	    staticClass: "ui small message",
	    class: {
	      'info': _vm.info, 'warning': _vm.warning, 'success': _vm.success, 'error': _vm.error
	    }
	  }, [_c('i', {
	    staticClass: "icon big",
	    class: [_vm.icon]
	  }), _c('span', [_vm._v(_vm._s(_vm.text))])])])
	},staticRenderFns: []}

/***/ }

});


// WEBPACK FOOTER //
// static/js/app.14af745f2e7c77868623.js